import React, { useCallback } from 'react';
import byteSize from 'byte-size';

import useSWR from 'swr';

import ConfirmationDialog from '../../../common/ConfirmationDialog/ConfirmationDialog';
import ContactSupport from '../../../common/Labels/ContactSupportLink';
import Label from '../../../common/Labels/Label';

import { measureStorageSizeForOrchestrations } from '../../../../utils/api_functions/deleteOrchestration';

export const useMultipleOrchestrationStorageSize = (orchIds) => {
  const {
    data,
    error,
    isLoading,
  } = useSWR(['orchestration-multi-storage-size', orchIds], measureStorageSizeForOrchestrations, {
    refreshInterval: 3000,
    loadingTimeout: 1000,
  });

  return {
    data,
    error,
    isLoading,
  }
}

export const OrchestrationRemovalModal = ({
  error = null,
  orchestrations = [],
  onOrchestrationsRemoved = () => {},
  showDialog = false,
  onDialogToggle = () => {},
}) => {
  const { data } = useMultipleOrchestrationStorageSize(orchestrations);
  const storage = data?.bytes || 0;
  const storageData = byteSize(storage);
  const storageLabel = `${storageData.value} ${storageData.unit}`;
  const isLastEntry = storage > 0;

  const onConfirm = useCallback(() => {
    onOrchestrationsRemoved(orchestrations);
  }, [orchestrations, onOrchestrationsRemoved])

  return (
    <ConfirmationDialog
      title="Delete Workloads"
      confirmButtonText="Delete"
      confirmButtonType="danger"
      showDialog={showDialog}
      onDialogToggle={onDialogToggle}
      modalAnimationKey="delete-orchestration-modal"
      onConfirm={onConfirm}
      error={error}
    >
      <div className="flex flex-col w-small-modal p-2 m-1">
        <Label>
          The selected workloads will be deleted and all associated tasks will be killed. This will also include orchestration artifacts if no other workloads are using them. Are you sure?
        </Label>
        {
          isLastEntry && (
            <Label className="mt-2">
              Storage to be freed: { storageLabel }
            </Label>
          )
        }
        {
          error && (
            <div className="p-2">
              <Label color="error" size="sm">
                Error while deleting the workload. Please try again or <ContactSupport>contact support</ContactSupport> if the issue persists.
              </Label>
            </div>
          )
        }
      </div>
    </ConfirmationDialog>
  )
};

export default OrchestrationRemovalModal;
